var map = {
	"./ad.svg": 2037,
	"./ae.svg": 2038,
	"./af.svg": 2039,
	"./ag.svg": 2040,
	"./ai.svg": 2041,
	"./al.svg": 2042,
	"./am.svg": 2043,
	"./ao.svg": 2044,
	"./ar.svg": 2045,
	"./as.svg": 2046,
	"./at.svg": 2047,
	"./au.svg": 2048,
	"./aw.svg": 2049,
	"./az.svg": 2050,
	"./ba.svg": 2051,
	"./bb.svg": 2052,
	"./bd.svg": 2053,
	"./be.svg": 2054,
	"./bf.svg": 2055,
	"./bg.svg": 2056,
	"./bh.svg": 2057,
	"./bi.svg": 2058,
	"./bj.svg": 2059,
	"./bl.svg": 2060,
	"./bm.svg": 2061,
	"./bn.svg": 2062,
	"./bo.svg": 2063,
	"./bq.svg": 2064,
	"./br.svg": 2065,
	"./bs.svg": 2066,
	"./bt.svg": 2067,
	"./bw.svg": 2068,
	"./by.svg": 2069,
	"./bz.svg": 2070,
	"./ca.svg": 2071,
	"./cd.svg": 2072,
	"./cf.svg": 2073,
	"./cg.svg": 2074,
	"./ch.svg": 2075,
	"./ci.svg": 2076,
	"./ck.svg": 2077,
	"./cl.svg": 2078,
	"./cm.svg": 2079,
	"./cn.svg": 2080,
	"./co.svg": 2081,
	"./cr.svg": 2082,
	"./cu.svg": 2083,
	"./cv.svg": 2084,
	"./cw.svg": 2085,
	"./cy.svg": 2086,
	"./cz.svg": 2087,
	"./de.svg": 2088,
	"./dj.svg": 2089,
	"./dk.svg": 2090,
	"./dm.svg": 2091,
	"./do.svg": 2092,
	"./dz.svg": 2093,
	"./ec.svg": 2094,
	"./ee.svg": 2095,
	"./eg.svg": 2096,
	"./er.svg": 2097,
	"./es.svg": 2098,
	"./et.svg": 2099,
	"./fi.svg": 2100,
	"./fj.svg": 2101,
	"./fk.svg": 2102,
	"./fm.svg": 2103,
	"./fo.svg": 2104,
	"./fr.svg": 2105,
	"./ga.svg": 2106,
	"./gb.svg": 2107,
	"./gd.svg": 2108,
	"./ge.svg": 2109,
	"./gf.svg": 2110,
	"./gh.svg": 2111,
	"./gi.svg": 2112,
	"./gl.svg": 2113,
	"./gm.svg": 2114,
	"./gn.svg": 2115,
	"./gp.svg": 2116,
	"./gq.svg": 2117,
	"./gr.svg": 2118,
	"./gt.svg": 2119,
	"./gu.svg": 2120,
	"./gw.svg": 2121,
	"./gy.svg": 2122,
	"./hk.svg": 2123,
	"./hn.svg": 2124,
	"./hr.svg": 2125,
	"./ht.svg": 2126,
	"./hu.svg": 2127,
	"./id.svg": 2128,
	"./ie.svg": 2129,
	"./il.svg": 2130,
	"./in.svg": 2131,
	"./io.svg": 2132,
	"./iq.svg": 2133,
	"./ir.svg": 2134,
	"./is.svg": 2135,
	"./it.svg": 2136,
	"./jm.svg": 2137,
	"./jo.svg": 2138,
	"./jp.svg": 2139,
	"./ke.svg": 2140,
	"./kg.svg": 2141,
	"./kh.svg": 2142,
	"./ki.svg": 2143,
	"./km.svg": 2144,
	"./kn.svg": 2145,
	"./kp.svg": 2146,
	"./kr.svg": 2147,
	"./kw.svg": 2148,
	"./ky.svg": 2149,
	"./kz.svg": 2150,
	"./la.svg": 2151,
	"./lb.svg": 2152,
	"./lc.svg": 2153,
	"./li.svg": 2154,
	"./lk.svg": 2155,
	"./lr.svg": 2156,
	"./ls.svg": 2157,
	"./lt.svg": 2158,
	"./lu.svg": 2159,
	"./lv.svg": 2160,
	"./ly.svg": 2161,
	"./ma.svg": 2162,
	"./mc.svg": 2163,
	"./md.svg": 2164,
	"./me.svg": 2165,
	"./mf.svg": 2166,
	"./mg.svg": 2167,
	"./mh.svg": 2168,
	"./mk.svg": 2169,
	"./ml.svg": 2170,
	"./mm.svg": 2171,
	"./mn.svg": 2172,
	"./mo.svg": 2173,
	"./mp.svg": 2174,
	"./mq.svg": 2175,
	"./mr.svg": 2176,
	"./ms.svg": 2177,
	"./mt.svg": 2178,
	"./mu.svg": 2179,
	"./mv.svg": 2180,
	"./mw.svg": 2181,
	"./mx.svg": 2182,
	"./my.svg": 2183,
	"./mz.svg": 2184,
	"./na.svg": 2185,
	"./nc.svg": 2186,
	"./ne.svg": 2187,
	"./nf.svg": 2188,
	"./ng.svg": 2189,
	"./ni.svg": 2190,
	"./nl.svg": 2191,
	"./no.svg": 2192,
	"./np.svg": 2193,
	"./nr.svg": 2194,
	"./nu.svg": 2195,
	"./nz.svg": 2196,
	"./om.svg": 2197,
	"./pa.svg": 2198,
	"./pe.svg": 2199,
	"./pf.svg": 2200,
	"./pg.svg": 2201,
	"./ph.svg": 2202,
	"./pk.svg": 2203,
	"./pl.svg": 2204,
	"./pm.svg": 2205,
	"./pr.svg": 2206,
	"./ps.svg": 2207,
	"./pt.svg": 2208,
	"./pw.svg": 2209,
	"./py.svg": 2210,
	"./qa.svg": 2211,
	"./re.svg": 2212,
	"./ro.svg": 2213,
	"./rs.svg": 2214,
	"./ru.svg": 2215,
	"./rw.svg": 2216,
	"./sa.svg": 2217,
	"./sb.svg": 2218,
	"./sc.svg": 2219,
	"./sd.svg": 2220,
	"./se.svg": 2221,
	"./sg.svg": 2222,
	"./sh.svg": 2223,
	"./si.svg": 2224,
	"./sk.svg": 2225,
	"./sl.svg": 2226,
	"./sm.svg": 2227,
	"./sn.svg": 2228,
	"./so.svg": 2229,
	"./sr.svg": 2230,
	"./ss.svg": 2231,
	"./st.svg": 2232,
	"./sv.svg": 2233,
	"./sx.svg": 2234,
	"./sy.svg": 2235,
	"./sz.svg": 2236,
	"./tc.svg": 2237,
	"./td.svg": 2238,
	"./tg.svg": 2239,
	"./th.svg": 2240,
	"./tj.svg": 2241,
	"./tk.svg": 2242,
	"./tl.svg": 2243,
	"./tm.svg": 2244,
	"./tn.svg": 2245,
	"./to.svg": 2246,
	"./tr.svg": 2247,
	"./tt.svg": 2248,
	"./tv.svg": 2249,
	"./tw.svg": 2250,
	"./tz.svg": 2251,
	"./ua.svg": 2252,
	"./ug.svg": 2253,
	"./us.svg": 2254,
	"./uy.svg": 2255,
	"./uz.svg": 2256,
	"./va.svg": 2257,
	"./vc.svg": 2258,
	"./ve.svg": 2259,
	"./vg.svg": 2260,
	"./vi.svg": 2261,
	"./vn.svg": 2262,
	"./vu.svg": 2263,
	"./wf.svg": 2264,
	"./ws.svg": 2265,
	"./ye.svg": 2266,
	"./za.svg": 2267,
	"./zm.svg": 2268,
	"./zw.svg": 2269
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2036;